import type { ReactNode } from 'react'
import css from './Text.module.css'

interface TextSmallProps {
    children: ReactNode
    className?: string
}

const TextSmall = ({ children, className }: TextSmallProps) => {
    return <p className={[css.small, className].filter(Boolean).join(' ')}>{children}</p>
}

export default TextSmall
